import {Route, Routes} from 'react-router';
import {AppShell} from './AppShell';
import {YearSelectorPage} from '../pages/YearSelectorPage';
import {FolderBrowserPage} from '../pages/FolderBrowserPage';

export function AppRoutes() {
    return (
        <Routes>
            <Route element={<AppShell/>}>
                <Route path="/" element={<YearSelectorPage/>}/>
                <Route path="/:year/*" element={<FolderBrowserPage/>}/>
            </Route>
        </Routes>
    );
}
